import posthog from "posthog-js";

// Accounts excluded from analytics via the "Internal / Test users" PostHog cohort
// (test_account_filters), which filters on the $internal_or_test_user person property.
const INTERNAL_EMAILS = [
  "fmgc13@gmail.com",
  "filipemgcorreia@gmail.com",
  "valoraone.sup@gmail.com",
  "22marcomartins@gmail.com",
];

export function getIdentifyProps(
  email: string,
  createdAt: string,
  billing?: {
    subscription_status: string | null;
    trial_ends_at: string;
    is_founding_member: boolean;
    is_ff: boolean;
  },
) {
  return {
    email,
    created_at: createdAt,
    $internal_or_test_user: INTERNAL_EMAILS.includes(email.toLowerCase()),
    ...(billing && {
      // "free" fallback matches the existing convention set by GET /me/settings
      // (pythonbackend/api/routers/users.py) — keep both writers of this
      // person property agreeing on the same value for a user with no
      // subscription yet, instead of one saying null and the other "free".
      subscription_status: billing.subscription_status ?? "free",
      trial_ends_at: billing.trial_ends_at,
      is_founding_member: billing.is_founding_member,
      // Read by the growth-dashboard insights to exclude friends & family
      // from trial/subscription counts — they never had real trial pressure.
      is_ff: billing.is_ff,
    }),
  };
}

export function initPostHog() {
  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  const host = import.meta.env.VITE_POSTHOG_HOST as string | undefined;
  if (key && host) {
    posthog.init(key, {
      api_host: host,
      person_profiles: "identified_only",
      defaults: "2026-01-30",
    });
  }
}

export function initPostHogIfConsented() {
  if (localStorage.getItem("cookie_consent") === "accepted") {
    initPostHog();
  }
}
